import { Radio } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { axonWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  axonWeb,
  {
    AxonListPage: () => import('./AxonListPage'),
    AxonDetailPage: () => import('./AxonDetailPage'),
    AxonAgentTab: () => import('./AxonAgentTab'),
  },
  {
    icons: { Radio },
  },
);
